import api from '@/libs/api'
import store from '@/store'

const projectId = () => store.state.app.projectId

export default {
  namespaced: true,
  state: {
    apiKeys: [],
    apiKey: null,
    fetchingApiKeys: false,
    fetchingApiKey: false,
    creatingApiKey: false,
    updatingApiKey: false,
    deletingApiKey: false,
    resultInfo: null,
  },
  mutations: {
    SET_API_KEYS(state, data) {
      state.apiKeys = data.result
      state.resultInfo = data.resultInfo
    },
    SET_FETCHING_API_KEYS(state, value) {
      state.fetchingApiKeys = value
    },
    SET_API_KEY(state, data) {
      state.apiKey = data.result ? data.result : data
    },
    SET_FETCHING_API_KEY(state, value) {
      state.fetchingApiKey = value
    },
    SET_CREATING_API_KEY(state, value) {
      state.creatingApiKey = value
    },
    SET_UPDATING_API_KEY(state, value) {
      state.updatingApiKey = value
    },
    SET_DELETING_API_KEY(state, value) {
      state.deletingApiKey = value
    },
    DELETE_API_KEY(state, id) {
      state.apiKeys = state.apiKeys.filter(k => k.id !== id)
    },
  },
  actions: {
    fetchApiKeys({ commit }, query) {
      const additional = query
        ? `?PageIndex=${query.pageIndex}&PageSize=${query.pageSize}`
        : ''
      commit('SET_FETCHING_API_KEYS', true)
      return new Promise((resolve, reject) => {
        api('captain')
          .get(`/projects/${projectId()}/apikeys${additional}`)
          .then(response => {
            commit('SET_API_KEYS', response.data)
            resolve(response)
          })
          .catch(error => {
            commit('SET_API_KEYS', { result: [], resultInfo: null })
            reject(error)
          })
          .finally(() => {
            commit('SET_FETCHING_API_KEYS', false)
          })
      })
    },
    fetchApiKey({ commit }, id) {
      commit('SET_FETCHING_API_KEY', true)
      return new Promise((resolve, reject) => {
        api('captain')
          .get(`/projects/${projectId()}/apikeys/${id}`)
          .then(response => {
            commit('SET_API_KEY', response.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_FETCHING_API_KEY', false)
          })
      })
    },
    createApiKey({ commit }, payload) {
      commit('SET_CREATING_API_KEY', true)
      return new Promise((resolve, reject) => {
        api('captain')
          .post(`/projects/${projectId()}/apikeys`, payload)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_CREATING_API_KEY', false)
          })
      })
    },
    updateApiKey({ commit }, payload) {
      commit('SET_UPDATING_API_KEY', true)
      return new Promise((resolve, reject) => {
        api('captain')
          .put(`/projects/${projectId()}/apikeys/${payload.id}`, payload.body)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_UPDATING_API_KEY', false)
          })
      })
    },
    deleteApiKey({ commit }, id) {
      commit('SET_DELETING_API_KEY', true)
      return new Promise((resolve, reject) => {
        api('captain')
          .delete(`/projects/${projectId()}/apikeys/${id}`)
          .then(response => {
            commit('DELETE_API_KEY', id)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_DELETING_API_KEY', false)
          })
      })
    },
  },
}
